import React, { useMemo } from 'react';

import { usePageContent } from '~/App/shared/hooks/use-page-content';

import { loadData } from './MemorialEdit.loadData';
import { MemorialEdit } from './MemorialEdit';

const View = (props: Record<string, unknown>) => {
  const pageContent = usePageContent();
  const children = useMemo(
    () => (pageContent ? <MemorialEdit {...pageContent} {...props} /> : null),
    [pageContent, props]
  );

  return children;
};

View.loadData = loadData;

export default View;
